module.exports = __webpack_public_path__ + "static/media/emoji.7a84910e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emoji.svg
// module id = 33
// module chunks = 1